import { CheckCircle2, XCircle, Loader2 } from "lucide-react";

export const DiscoveryPaymentResult = ({ state, booking, onRetry }) => {
  if (state === "checking") {
    return (
      <div className="py-10 text-center" data-testid="discovery-payment-checking">
        <Loader2 className="mx-auto h-10 w-10 animate-spin text-[#0A8B85]" />
        <p className="mt-4 text-base font-bold text-[#0B2A28]">Confirming your payment…</p>
      </div>
    );
  }
  if (state === "paid" && booking) {
    const start = new Date(booking.start_at);
    const end = new Date(booking.end_at);
    const t = (d) => d.toLocaleTimeString("en-GB", { hour: "numeric", minute: "2-digit", hour12: true, timeZone: "Africa/Nairobi" }).toLowerCase().replace(" ", "");
    return (
      <div className="py-6 text-center" data-testid="discovery-payment-success">
        <CheckCircle2 className="mx-auto h-12 w-12 text-[#0A8B85]" />
        <p className="mt-4 text-xl font-extrabold text-[#0B2A28]">Your Discovery Session is confirmed</p>
        <p className="mt-2 text-sm text-neutral-600">
          {start.toLocaleDateString("en-GB", { weekday: "long", day: "numeric", month: "long", year: "numeric" })} · {t(start)} – {t(end)} EAT · {booking.format_label}
        </p>
        <p className="mt-4 text-sm leading-relaxed text-neutral-600">
          A confirmation email and calendar invite are on their way to <span className="font-semibold text-[#0B2A28]">{booking.email}</span>.
          {booking.format === "virtual" ? " Your meeting link will be sent separately before the session." : " See you at SNDBX International, Hurlingham, Nairobi."}
        </p>
      </div>
    );
  }
  return (
    <div className="py-6 text-center" data-testid="discovery-payment-failed">
      <XCircle className="mx-auto h-12 w-12 text-red-500" />
      <p className="mt-4 text-lg font-extrabold text-[#0B2A28]">Payment not completed</p>
      <p className="mt-2 text-sm text-neutral-600">Your slot has not been booked. You can try again below — nothing has been charged.</p>
      <button type="button" onClick={onRetry} className="mt-5 rounded-full bg-[#0A8B85] px-6 py-3 text-sm font-bold text-white hover:bg-[#0C9F97]" data-testid="discovery-retry-btn">
        Try again
      </button>
    </div>
  );
};
